<template>
	<div>
		<v-form ref="form" v-model="valid" :lazy-validation="lazy">
			<form-header>
				<v-img v-bind:src="ui.logo" contain class="neteller-logo m-t-10 m-b-15"/>
				<template v-slot:processing_time>{{ bundleFieldValue('processing_time') }}</template>
				<template v-slot:fee>{{ bundleFieldValue('withdrawal_fee') }}</template>
				<template v-slot:min_withdrawal>{{ bundleFieldValue('min_withdrawal') }} EUR</template>
				<template v-slot:max_withdrawal>{{ bundleFieldValue('max_withdrawal') }} EUR</template>
			</form-header>
			<v-expansion-panel-content v-if="form" class="p-lr-10">
				<div class="withdrawal-summary-container">
					<v-row class="p-10 custom-card white-text gateway-inner-wrapper font-sm" :class="ui.classes">
						<v-col cols="8">
							<p>Amount to be withdrawn:</p>
						</v-col>
						<v-col cols="4">
							<p class="bold">{{ totalAmountToBeWithdrawn }} {{ currency }}</p>
						</v-col>
						<v-col cols="8">
							<p>Fee:</p>
						</v-col>
						<v-col cols="4">
							<p class="bold">{{ customerFee }} {{ currency }}</p>
						</v-col>
						<div class="divider bg-white m-t-5 m-b-5 opacity-50"></div>
						<v-col cols="8">
							<p>Total Amount:</p>
						</v-col>
						<v-col cols="4">
							<p class="bold">{{ total }} {{ currency }}</p>
						</v-col>
					</v-row>
				</div>

				<div class="withdrawal-form-container">
					<v-row class="gateway-inner-wrapper m-t-15">
						<v-text-field
							v-model="form.email"
							:rules="formRules.email"
							ref="email"
							outlined
							label="Email"
							required
							v-bind:readonly="hasPaymentOptionEmailRegistered"
						></v-text-field>
						<v-text-field
							v-model="form.amount"
							:rules="formRules.amount"
							ref="amount"
							outlined
							label="Enter Amount"
							suffix="EUR"
							class="gateway-neteller"
							type="number"
							required
						></v-text-field>
						<div class="verification-wrapper">
							<v-text-field
								v-model="form.verification_code"
								:rules="formRules.verification_code"
								ref="verificationCode"
								outlined
								label="Verification Code"
								class="verification-field"
								type="number"
								required
							></v-text-field>
							<v-btn color="primary" class="black--text gradient-yellow get-code-btn" @click="requestCode" :loading="loadingGetCode">Get Code</v-btn>
						</div>
					</v-row>
				</div>

				<v-row class="request-btn-wrapper gateway-inner-wrapper flex-right">
					<v-btn block class="white-text gradient-green request-btn" @click="submit" :loading="loading" v-bind:disabled="!valid">Send Request</v-btn>
				</v-row>
			</v-expansion-panel-content>
		</v-form>
		<get-code-success-dialog
			ref="childGetCodeSuccess"
			title="Please check your inbox"
			message="We’ve sent the OTP code to"
			:recipient="memberEmail"
			:open="dialog">
		</get-code-success-dialog>
		<error-dialog
			ref="childError"
			title="Error"
			:message="message"
			:open="errorDialog"
			toPage="">
		</error-dialog>
		<success-dialog
			ref="childSuccess"
			title="Success"
			:message="message"
			:open="successDialog"
			toPage="/transaction-history">
		</success-dialog>
	</div>
</template>


<script>
import {withdrawalFormMixin} from '../../mixins/withdrawal-form-mixin';

export default {
	name: 'DefaultWithdrawalForm',
	mixins: [withdrawalFormMixin],
}
</script>

<style scoped>

</style>